import React from 'react';

import Markdown from 'common/markdown/Markdown';

import type { Comment } from 'common/api/resources/comments';

import 'css/components/comment/_CommentBody.scss';

type Props = {
  comment: Comment;
};

const CommentBody = ({ comment }: Props) => {
  return (
    <div className="commentBody">
      <div className="value">
        <Markdown contents={comment.value} mentions={comment.mentionedUsers} />
      </div>
    </div>
  );
};

export default CommentBody;
